import { Component, app } from "modular-openscriptjs";

const h = app("h");

export default class LoadingScreen extends Component {

  render(...args) {
    return h.div(
      {
        class:
          "bg-light position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center overflow-hidden",
        style: "z-index: 9999;",
      },
      h.div(
        { class: "d-flex flex-column align-items-center gap-5" },

        h.span(
          {
            class: "fade show",
            style: "width: 150px;",
          },

          h.video(
            {
              class: "border border-5 rounded-circle",
              style: "aspect-ratio: 1 / 1; width: 100%; object-fit: cover;",
              autoplay: "",
              muted: "",
              loop: "",
              playsinline: "",
            },

            h.source({
              src: "/assets/videos/loading-carata-2.mp4",
              type: "video/mp4",
            }),

            "Your browser does not support the video tag.",
          ),
        ),

        h.div(
          {
            class: "typewriter",
            style: "max-width:fit-content;",
          },

          h.p(
            { class: "typewritten fw-bold" },

            "Getting Everything Ready For You...",
          ),
        ),
      ),
      ...args,
    );
  }

}
